import { AccountStage, AccountStatus, AccountType, DocumentStage } from '@app/codegen';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

export const AccountsScreenFilterSchema = yup
	.object({
		search: yup.string().default(''),
		accountStage: yup
			.mixed<AccountStage>()
			.oneOf([...Object.values(AccountStage)])
			.default(undefined),
		accountType: yup
			.mixed<AccountType>()
			.oneOf([...Object.values(AccountType)])
			.default(undefined),
		status: yup.mixed<AccountStatus>().oneOf(Object.values(AccountStatus)).default(undefined),
		createdFrom: yup.date().default(undefined),
		createdTo: yup.date().default(undefined),
		documentStage: yup
			.mixed<DocumentStage.SENT_TO_CLIENT | DocumentStage.SIGNED>()
			.oneOf([DocumentStage.SENT_TO_CLIENT, DocumentStage.SIGNED])
			.default(undefined),
		phone: yup.string().default('').max(12),
	})
	.defined();

export type FilterAccountsForm = yup.TypeOf<typeof AccountsScreenFilterSchema>;

export function useAccountsScreenFilterForm() {
	return useForm<FilterAccountsForm>({
		mode: 'all',
		resolver: yupResolver(AccountsScreenFilterSchema),
		defaultValues: AccountsScreenFilterSchema.cast({}),
	});
}
